import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchPromotionType, updatePromotionType } from "actions/promotionType";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/PromotionType/Form";

class PromotionTypeEdit extends Component {
  componentDidMount() {
    const { match, fetchPromotionType } = this.props;
    const id = match.params.promotionTypeId;
    fetchPromotionType(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.promotionType.data;

    return Object.assign(
      {},
      {
        ...rest
      }
    );
  }

  updatePromotionType(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updatePromotionType, history } = this.props;

    toggleFullPageSpinner(true);

    updatePromotionType(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated PromotionType Success", infoClassName: "is-success" });
        history.push(`/promotion-types`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.promotionTypeId;

    this.updatePromotionType(id, data);
  };

  render() {
    const { promotionType } = this.props;

    if (promotionType.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return <Form handleFormSubmit={this.handleFormSubmit} defaultValues={defaultValues} />;
  }
}

const mapStateToProps = ({ promotionType }) => ({
  promotionType
});

export default connect(
  mapStateToProps,
  {
    fetchPromotionType,
    updatePromotionType,
    toggleFullPageSpinner,
    toggleNotification
  }
)(PromotionTypeEdit);



// WEBPACK FOOTER //
// ./src/pages/PromotionType/Edit/index.js